import { FEATURE_FLAGS_NAMES, LAYOUT_TABS } from '@silverfort-nodelibs/common/utils/consts';
import { SYSTEM_MODE_HIDDEN_VIEWS } from '@silverfort-nodelibs/common/utils/system-mode-config';
import useFeature from '../../hooks/featureFlags/useFeature';
import Tabs from '../../../sf-components/Tabs/Tabs';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { Icon, Icons } from '@silverfort/sf-components';

const NewCategory = ({ category, fields, visibleFields, selectedTab, setSelectedTab, children }) => {
    const systemMode = useFeature(FEATURE_FLAGS_NAMES.SystemMode);
    const history = useHistory();

    const availableTabs = visibleFields
        ? Object.values(fields).filter(
              (subcategory) =>
                  visibleFields[subcategory.id] &&
                  !SYSTEM_MODE_HIDDEN_VIEWS[LAYOUT_TABS.SYSTEM_SETUP.ID][systemMode]?.tabs.has(subcategory.id)
          )
        : Object.values(fields);

    //container height is a consequence of mainStyle.css settings classes
    return (
        <div className="bg-sf-white h-[calc(100vh-62px)] overflow-y-auto">
            <div className="font-sf">
                <div className={`p-6 text-16 h-16 font-medium text-sf-gray-800 flex gap-4`}>
                    <div>{category.NAME}</div>
                    {category.EARLY_AVAILABILITY && (
                        <div className="h-6 px-2 items-center content-center rounded bg-sf-positive-100 w-fit text-sm font-medium flex gap-2">
                            <Icon className="text-[#00B283]" icon={Icons.Star} />
                            <div className="text-[#00B283]">Early Availability</div>
                        </div>
                    )}
                </div>
                <Tabs
                    onClick={(tabId) => {
                        history.push(`/Settings/${category.NAME}#${tabId}`);
                        setSelectedTab && setSelectedTab(tabId);
                    }}
                    selectedTab={selectedTab}
                    disabledTabs={availableTabs.filter((tab) => tab.disabled).map((tab) => tab.id)}
                    tabs={availableTabs.map((tab) => {
                        return { name: tab.name, value: tab.id, tooltip: tab.tooltip };
                    })}
                    className={'mx-6'}
                />
            </div>
            {children && <div className={'px-6 py-4'}>{children}</div>}
        </div>
    );
};

export default NewCategory;
